export const eventContextChanged = 'cam-context-switcher-context-changed';
export const eventCardClicked = 'cam-context-switcher-context-card-clicked';
export const eventMenuItemClicked = 'cam-context-switcher-menu-item-clicked';
export const eventContextSwitcherReady = 'cam-context-switcher-ready';
export const eventFavoritesUpdated = 'cam-context-switcher-favorites-updated';

export const defaultConfig = {
  apiUrl: 'https://cam.ctl.io',
  enabledContexts: [
    'favorite',
    'organization',
    'costcenter',
    'workspace'
  ]
};



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-constants.js